import React from 'react';
import { Users, Building2, Database } from 'lucide-react';

export default function Home() {
  return (
    <div className="space-y-20 px-4 py-12 lg:px-0">
      <section className="bg-gray-50   rounded-2xl p-8 md:p-12 max-w-4xl mx-auto">
        <h1 className="text-xl md:text-5xl font-extrabold text-center">
          <span className="text-red-600">Selamat Datang di </span>Kelompok 6
        </h1>
        <p className="mt-4 text-gray-700 text-center leading-relaxed">
          Kelompok 6 adalah kelompok dari mata kuliah Implementasi Pengujian Perangkat Lunak kelas IF-47-08, yang dibimbing oleh Bapak Muhammad Shiddiq Azis. Tujuan kami adalah membuat website Hall of Fame untuk menampilkan tugas pada minggu ini.
Dalam kelompok ini terdapat beberapa peran penting, yaitu Configuration Manager (CM), Programmer, Customer, dan Auditor
        </p>
      </section>



      
    </div>
  );
}
